export const PARTICIPANT_HEALTH_INFORMATION = 'participant_health_information';
export const PARTICIPANT_PERSONAL_MEDICAL_HISTORY = 'participant_personal_medical_history';
export const PARTICIPANT_FAMILY_MEDICAL_HISTORY = 'participant_family_medical_history';
export const PARTICIPANT_CONSULTATION = 'consultation';



// WEBPACK FOOTER //
// ./src/constants/person-helath-category.js